import { render, staticRenderFns } from "./problem-finish.vue?vue&type=template&id=eb55b8fe&"
import script from "./problem-finish.vue?vue&type=script&lang=js&"
export * from "./problem-finish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports